import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/wedding-budget',
  component: () => import('../../routes/WeddingBudget.svelte'),
  card: {
    id: 'wedding-budget',
    title: 'Wedding Budget',
    description: 'Allocate your wedding budget across categories with typical percentage breakdowns for venue, catering, and more.',
    icon: 'favorite',
    iconBgClass: 'bg-pink-50',
    iconTextClass: 'text-pink-600',
    href: '/wedding-budget',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Wedding Budget Calculator – Plan Your Wedding Budget by Category',
    description: 'Free wedding budget calculator to allocate your wedding budget across categories with typical percentage breakdowns. Plan spending for venue, catering, photography, flowers, music, attire, and more. Adjust percentages and see your budget breakdown instantly.',
  },
};

export default meta;
